import axios from 'axios';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components'

import { Flex, Text, Spinner } from "../../../../components";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, TextArea } from "../../components";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import WaitingUser from "./WaitingUser";

const Header = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 15px 30px;
`;

const Search = styled.input`
  background: transparent;
  flex-grow: 1;
  margin-right: 20px;
  height: 100%;
  color: #fff;
  
  &::placeholder {
    color: #7178B2
  }
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg}
`;

const Content = styled(Flex)`
  padding: 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const Waitlists = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [waitlist, setWaitlist] = useState(null);
  const [licenseTypes, setLicenseTypes] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setEditModal] = useState(false);

  const [emailPayload, setEmailPayload] = useState({
    password: "",
    license_type_id: null,
    stockAmount: 0,
    force_cancel: 0,
    count: 0,
    whitelist: null,
    content: null,
    subject: "Waitlist Entry Update",
    header: "Congratulations!",
    subHeader: "You have been selected from our waitlist.",
    emoji: "🎉",
    labelOverwrite: ""
  });

  const [editWaitingUserData, setEditWaitingUserData] = useState({
    discord_id: null,
    sent_count: 0,
    sent: false,
  });

  const editWaitingUser = (waitingUserData) => {
    setEditModal(true);
    setEditWaitingUserData({
      discord_id: waitingUserData.discord_id,
      sent_count: waitingUserData.sent_count,
      sent: waitingUserData.sent,
    })
  }

  const hideEditModal = () => {
    setEditModal(false);
  }

  const generateWaitlist = () => {

    setIsLoading(true);

    axios({
      method: 'POST',
      url: '/api/admin/waitlist/create-waitlist',
      data: emailPayload,
    }).then(res => {
      setWaitlist(res.data.waitlist);
      setLicenseTypes(res.data.license_types);
      setShowModal(false);
      setIsLoading(false);
    });

  }


  const updateWaitingUser = () => {

    setIsLoading(true);

    axios({
      method: 'put',
      url: '/api/admin/waitlist/update-waiting-user',
      data: editWaitingUserData,
    }).then(res => {
      setWaitlist(res.data.waitlist);
      hideEditModal();
      setIsLoading(false);
    });

  }

  const refreshList = () => {

    setIsLoading(true);

    axios
      .get('/api/admin/waitlist')
      .then(res => {
        setWaitlist(res.data.waitlist);
        setLicenseTypes(res.data.license_types);
        if (res.data.license_types.length > 0) {
          setEmailPayload({
            ...emailPayload,
            license_type_id: res.data.license_types[0].id
          })
        }
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }

  const searchWaitlist = (value) => {

    if (value.length > 0) {

      axios
        .get('/api/admin/waitlist/search-waitlist?search=' + value)
        .then(res => {
          setWaitlist(res.data.waitlist);
        })
        .catch(err => {
          console.error(err);
        });

    } else {
      axios
        .get('/api/admin/waitlist')
        .then(res => {
          setWaitlist(res.data.waitlist);
        })
        .catch(err => {
          console.error(err);
        });
    }

  }

  const getWhitelist = () => {
    setIsLoading(true);
    axios
      .get('/api/admin/waitlist/generate-whitelist?amount=' + emailPayload.stockAmount)
      .then(res => {
        setEmailPayload({
          ...emailPayload,
          whitelist: res.data.whitelist.map(w => { return w.email })
        })
        console.log(res.data.whitelist.map(w => { return w.email }))
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    axios
      .get('/api/admin/waitlist')
      .then(res => {
        setWaitlist(res.data.waitlist);
        setLicenseTypes(res.data.license_types);
        if (res.data.license_types.length > 0) {
          setEmailPayload({
            ...emailPayload,
            license_type_id: res.data.license_types[0].id
          })
        }
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Header h="90px" w="100%" align="center">
        <Search placeholder="Search waitlist" onKeyPress={e => e.key == "Enter" ? searchWaitlist(e.target.value) : ""} />
        <Flex fg="1" />
        <Button bg="#0393FF" onClick={() => setShowModal(true)}>Send Email(s)</Button>
        <Flex w="12px" />
        <Button bg="#F32FE0" onClick={() => refreshList()}>Refresh List</Button>
      </Header>
      <Content w="100%" minw="900px" dir="column">
        <HeaderRow w='100%' minw="840px">
          <Flex w="15%">Discord ID</Flex>
          <Flex w="15%">Email</Flex>
          <Flex w="15%">Sent</Flex>
          <Flex w="15%">Sent Count</Flex>
          <Flex w="15%">Sent At</Flex>
        </HeaderRow>
        {waitlist.map((value) => {
          return <WaitingUser editWaitingUser={editWaitingUser} data={value} />
        })}
      </Content>

      <NotificationContainer />

      {showModal &&
        <ModalContainer>
          <Modal maxWidth="100%" maxHeight="90%" dir="column">
            <Text.Heading size="18">Send Email</Text.Heading>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Label>Password</Label>
              <Flex w="740px" />
              <Label>License Type</Label>
            </Flex>
            <Flex h="12px" />
            <Flex dir="row" w="100%">
              <Input
                type="text"
                placeholder="Password"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    password: e.target.value
                  })
                }}
              />
              <Flex w="16px" />
              <Select
                value={emailPayload.license_type_id}
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    license_type_id: e.target.value
                  })
                }}
              >
                {licenseTypes.map((value) => {
                  return <option value={value.id}>{value.name} | {value.label}</option>
                })}
              </Select>
            </Flex>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Label>Amount</Label>
            </Flex>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              <Input
                type="number"
                placeholder="Amount"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    stockAmount: e.target.value
                  })
                }}
                value={emailPayload.stockAmount}
              />
            </Flex>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Label>Force Cancel</Label>
              <Flex w="720px" />
              <Label>Count</Label>
            </Flex>
            <Flex h="16px" />
            <Flex dir="row" w="100%">
              <Select
                value={emailPayload.force_cancel}
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    force_cancel: e.target.value
                  })
                }}
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Select>
              <Flex w="16px" />
              <Select
                value={emailPayload.count}
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    count: e.target.value
                  })
                }}
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Select>
            </Flex>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton w="100%" onClick={() => getWhitelist()} bg="#202441">Generate List</ModalButton>
            </Flex>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Label>Whitelisted ID(s)</Label>
              <Flex w="435px" />
              <Label>Content</Label>
              <Flex w="485px" />
              <Label>Label Overwrite</Label>
            </Flex>
            <Flex h="16px"></Flex>
            <Flex dir="row" w="100%">
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    whitelist: e.target.value.split('\n')
                  })
                }}
                value={emailPayload.whitelist != null ? emailPayload.whitelist.map(w => { return w }).join('\n') : ''}
              />
              <Flex w="24px" />
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    content: e.target.value
                  })
                }}
                value={emailPayload.content != null ? emailPayload.content : ''}
              />
              <Flex w="24px" />
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    labelOverwrite: e.target.value
                  })
                }}
                value={emailPayload.labelOverwrite != null ? emailPayload.labelOverwrite : ''}
              />
            </Flex>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <Label>Subject</Label>
              <Flex w="360px" />
              <Label>Header</Label>
              <Flex w="360px" />
              <Label>Sub-Header</Label>
              <Flex w="360px" />
              <Label>Emoji</Label>
            </Flex>
            <Flex h="16px"></Flex>
            <Flex dir="row" w="100%">
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    subject: e.target.value
                  })
                }}
                value={emailPayload.subject}
              />
              <Flex w="24px" />
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    header: e.target.value
                  })
                }}
                value={emailPayload.header}
              />
              <Flex w="24px" />
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    subHeader: e.target.value
                  })
                }}
                value={emailPayload.subHeader}
              />
              <Flex w="24px" />
              <TextArea height="50px"
                onChange={(e) => {
                  setEmailPayload({
                    ...emailPayload,
                    emoji: e.target.value
                  })
                }}
                value={emailPayload.emoji}
              />
            </Flex>
            <Flex h="24px"></Flex>
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowModal(false)} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={generateWaitlist}>Send Emails</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      {showEditModal &&
        <ModalContainer>
          <Modal maxHeight="80%" dir="column">
            <Text.Heading size="18">Update Waiting User</Text.Heading>
            <Flex h="24px" />
            <Label>Sent Count</Label>
            <Flex h="16px" />
            <Input
              type="text"
              placeholder="Password"
              value={editWaitingUserData.sent_count}
              onChange={(e) => {
                setEditWaitingUserData({
                  ...editWaitingUserData,
                  sent_count: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Flex w="24px" />
            <Label>Sent</Label>
            <Flex h="16px" />
            <Select
              value={editWaitingUserData.sent}
              onChange={(e) => {
                setEditWaitingUserData({
                  ...editWaitingUserData,
                  sent: e.target.value
                })
              }}
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </Select>
            <Flex h="24px" />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={hideEditModal} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={updateWaitingUser}>Save</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }
    </>
  )
}

export default Waitlists;
